export default {
  geolocation: {
    lat: '38.722231',
    lng: '-9.139364',
    label: '1150-343 Lisboa',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
